/* Collections on the full search results page.
   Fetches the same predictive-search (suggest) API the header dropdown uses,
   so the results page shows exactly the collections the dropdown shows,
   then filters to collections linked in the main menu (allowed-handles attr)
   so SEO-only landing collections never appear. Fails open: if no allow-list
   is provided, all matches are shown.
   Self-contained: no dependency on the theme's Global core.
   Added 2026-07-25, menu filter 2026-07-27 (marketing/UX findability project). */

customElements.define('search-collection-results', class extends HTMLElement {
    connectedCallback() {
        if (this._loaded) return;
        this._loaded = true;
        this._load();
    }

    async _load() {
        const terms = this.getAttribute('terms');
        const limit = this.getAttribute('limit') || 12;
        const suggestUrl = this.getAttribute('suggest-url') || '/search/suggest.json';
        const allowedAttr = (this.getAttribute('allowed-handles') || '').trim();
        const allowed = allowedAttr ? new Set(allowedAttr.split(',').map(h => h.trim()).filter(Boolean)) : null;

        if (!terms) { this.remove(); return; }

        try {
            const url = suggestUrl + '?q=' + encodeURIComponent(terms) + '&resources[type]=collection&resources[limit]=' + limit;
            const response = await fetch(url, { headers: { 'Accept': 'application/json' } });
            if (!response.ok) { this.remove(); return; }

            const json = await response.json();
            let collections = (((json || {}).resources || {}).results || {}).collections || [];

            if (allowed && allowed.size) {
                collections = collections.filter((collection) => {
                    const path = (collection.url || '').split('?')[0].replace(/\/$/, '');
                    const handle = path.substring(path.lastIndexOf('/') + 1);
                    return allowed.has(handle);
                });
            }

            if (!collections.length) { this.remove(); return; }

            const content = this.querySelector('[data-element="content"]');
            if (!content) { this.remove(); return; }

            collections.forEach((collection) => {
                const link = document.createElement('a');
                link.className = 'search-collection-results-card';
                link.href = collection.url;
                const label = document.createElement('span');
                label.textContent = collection.title;
                link.appendChild(label);
                content.appendChild(link);
            });

            this.hidden = false;
        } catch (error) {
            this.remove();
        }
    }
});